import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Engagement } from '../models/engagement.model';
import { EngagementClient } from '../models/engagementClient.model';

@Injectable()
export class CommonDataServicesService {
  constructor(private http: HttpClient) {}
  public validateEngagementId(engagementId: string): Observable<Engagement> {
    return this.http.get<Engagement>('api/CommonDataServices/Engagement/' + engagementId);
  }
  public getEngagementClient(engagementId: string): Observable<EngagementClient> {
    return this.http.get<EngagementClient>('api/CommonDataServices/EngagementClient/' + engagementId);
  }
}
